(function () {
  'use strict';

  /*
   * Animations page produit — SANS GSAP (mission 23).
   * Auparavant : gsap.min.js + ScrollTrigger.min.js (~115 Ko) + ~2,5 s de CPU
   * au bootup + un parallax « scrub » lié au scroll (le type d'animation le
   * plus coûteux). Remplacé par un IntersectionObserver natif qui se contente
   * d'ajouter les classes de révélation ; toute l'animation vit dans
   * pelux-anim.css (transitions transform/opacity = compositées).
   *
   * Garde-fou FOUC : les classes qui masquent (.plx-s-reveal, .plx-wi, etc.)
   * ne sont AJOUTÉES que par ce script. S'il ne s'exécute pas, tout reste
   * visible par défaut. En reduced-motion ou sans IntersectionObserver, on
   * révèle tout immédiatement.
   */

  var REDUCED = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* ---- Titres découpés mot par mot ---- */
  var headingSelectors = [
    '.pelux-benefits__title',
    '.pelux-steps__title',
    '.pelux-sg__title',
    '.pelux-specs__title',
    '.pelux-final__title',
    '.pelux-trust__heading',
  ];
  var headings = [];
  if (!REDUCED) {
    document.querySelectorAll(headingSelectors.join(',')).forEach(function (el) {
      var words = el.textContent.trim().split(/\s+/);
      var delay = 0;
      el.innerHTML = words
        .map(function (w) {
          var s =
            '<span class="plx-wo"><span class="plx-wi" style="--wd:' +
            delay +
            'ms">' +
            w +
            '</span></span>';
          delay += 65;
          return s;
        })
        .join(' ');
      headings.push(el);
    });
  }

  /* ---- Index de stagger pour les grilles (benefits, steps) ---- */
  document.querySelectorAll('[data-stagger-parent]').forEach(function (parent) {
    parent.querySelectorAll('[data-stagger]').forEach(function (child, i) {
      child.style.setProperty('--stagger-i', i);
    });
    parent.classList.add('plx-animate-ready');
  });

  /* ---- Sections à révéler au scroll ---- */
  var sectionClasses = [
    '.pelux-moment', '.pelux-feature', '.pelux-proof', '.pelux-faq', '.pelux-trust',
    '.pelux-benefits', '.pelux-steps', '.pelux-sg', '.pelux-specs', '.pelux-final',
    '.image-with-text', '.collapsible-content',
  ];
  var reveals = Array.prototype.slice.call(document.querySelectorAll(sectionClasses.join(',')));
  reveals.forEach(function (el) { el.classList.add('plx-s-reveal'); });

  var staggerParents = Array.prototype.slice.call(document.querySelectorAll('[data-stagger-parent]'));

  function revealAll() {
    reveals.forEach(function (el) { el.classList.add('plx-in'); });
    staggerParents.forEach(function (el) { el.classList.add('plx-in'); });
    headings.forEach(function (el) { el.classList.add('plx-words-go'); });
  }

  if (REDUCED || !('IntersectionObserver' in window)) {
    revealAll();
    return;
  }

  /* ---- Saut d'ancre : tout révéler, SANS transition ----
   * Après un saut (« Voir les avis → », « Revenir à l'achat ↑ », « Explorer en 3D ↓ »,
   * guide des tailles sans <dialog>…), la zone d'arrivée restait blanche : les
   * sections sont à opacité 0 jusqu'à ce que l'observateur les croise, puis
   * s'animent 0,85 s. La classe `plx-saut` sur <html> coupe transitions et
   * animations (pelux-anim.css) et on révèle tout d'un coup. Posée une fois, elle
   * reste : après un saut, la page n'anime plus rien — elle s'affiche. */
  function sauter() {
    document.documentElement.classList.add('plx-saut');
    revealAll();
  }
  document.addEventListener(
    'click',
    function (e) {
      var a = e.target.closest && e.target.closest('a[href^="#"]');
      if (a && a.getAttribute('href').length > 1) sauter();
    },
    true // capture : avant les gestionnaires qui font défiler la page
  );
  window.addEventListener('hashchange', sauter);
  if (window.location.hash.length > 1) sauter(); // arrivée directe sur /products/…#pelux-avis

  /* ---- IntersectionObserver natif : déclenche les transitions CSS ---- */
  var io = new IntersectionObserver(
    function (entries, obs) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        var el = e.target;
        el.classList.add('plx-in');
        if (el.hasAttribute('data-plx-heading')) el.classList.add('plx-words-go');
        obs.unobserve(el);
      });
    },
    { rootMargin: '0px 0px -12% 0px', threshold: 0.08 }
  );

  reveals.forEach(function (el) { io.observe(el); });
  staggerParents.forEach(function (el) { io.observe(el); });
  headings.forEach(function (el) {
    el.setAttribute('data-plx-heading', '');
    io.observe(el);
  });
})();
